<template>
<div>
  <b-form v-if="loaded" @submit="onSubmit" @cancel="onCancel">
    <template v-for="(item, index) in metadata">
      <FormComponent v-if="item.type != 'ignore'" :metadata='item' :dbfield='index' :key='"comp_"+index' v-model="formx[index]"
        :isEdit="$route.params.id !== '0' && $route.params.id !== 0"
        v-on:updatex="updatex" />
    </template>
    <br/>
    <b-alert variant="info" :show="msg != null">{{msg}}</b-alert>
    <b-button type="button" variant="primary" @click="onSubmit">Guardar</b-button>
    <b-button type="button" variant="danger" @click="onCancel">Cancelar</b-button>
  </b-form>
</div>
</template>
<script>
import Base from './Base.vue'
import FormComponent from './FormComponents/FormComponent.vue'
import { mapState, mapActions } from 'vuex'

export default {
  extends: Base,
  components: {
    FormComponent
  },
  watch: {
    db (to, from) {
      // this.loaded = false
      if (to) {
        this.loadForm()
      }
    },
    formx () {
      // this.$set(this.$root, 'currmodel', this.formx)
      this.update_currmodel(this.formx)
    }
  },
  data () {
    return {
      test: {},
      formx: { '_attachments': {} },
      loaded: true // false
    }
  },
  computed: {
    ...mapState([
      'currmodel',
      'user'
    ])
  },
  methods: {
    ...mapActions([
      'update_currmodel',
      'setMessage'
    ]),
    onSubmit () {
      var d = new Date()
      let obj = this
      let savep = null
      if (this.formx._id) {
        savep = this.savedata(this.formx._id, this.formx)
      } else {
        if (this.$route.params.typex === 'server') {
          this.formx.username = this.user.name
        }
        savep = this.savedata(d.getTime(), this.formx)
      }
      savep.then(function () {
        obj.$router.push({ name: 'list', params: { typex: obj.$route.params.typex, json: obj.$route.params.json } })
      })
    },
    onCancel () {
      let obj = this
      obj.$router.push({ name: 'list', params: { typex: obj.$route.params.typex, json: obj.$route.params.json } })
    },
    loadForm () {
      let obj = this
      if (this.$route.params.id !== '0' && this.$route.params.id !== 0) {
        this.getdata(this.$route.params.id, false).then(function (data) {
          obj.$set(obj, 'formx', data)
          obj.loaded = true
        }).catch(function (err) {
          console.log(err)
          obj.setMessage('loadForm: ' + JSON.stringify(err))
        })
      } else {
        obj.loaded = true
      }
    },
    updatex (data) {
      // console.log(data)
      if (data.action === 'set') {
        if (!(data.target in this.formx)) { this.$set(this.formx, data.target, {}) }
        if (data.id === null) {
          this.$set(this.formx, data.target, data.object)
        } else {
          this.$set(this.formx[data.target], data.id, data.object)
        }
      } else if (data.action === 'delete') {
        if (data.target in this.formx) {
          if (data.id === null) {
            this.$delete(this.formx, data.target)
          } else {
            this.$delete(this.formx[data.target], data.id)
          }
        }
      }
    }
  }
}
</script>
